import React from 'react';
import { connect } from 'react-redux';
import ImmutablePropTypes from 'react-immutable-proptypes';
import { libraryShape, availabilityShape } from '@bibliocommons/bc-prop-types';
import { selectCurrentLibrary } from 'app/selectors/LibrarySelector';
import { selectLibraryEntities, selectAvailabilityEntities } from 'app/selectors/EntitiesSelector';
import { selectAvailabilityProbes } from 'app/selectors/bibs/AvailabilitySelector';
import ConnectedLibraryPanel from './ConnectedLibraryPanel';

export class ConnectedLibraryPanelContainer extends React.PureComponent {
  render() {
    return <ConnectedLibraryPanel {...this.props} />;
  }
}

ConnectedLibraryPanelContainer.propTypes = {
  probes: ImmutablePropTypes.list,
  libraries: ImmutablePropTypes.mapOf(libraryShape).isRequired,
  availabilities: ImmutablePropTypes.mapOf(availabilityShape).isRequired,
  currentLibrary: libraryShape.isRequired
};

const mapStateToProps = state => ({
  probes: selectAvailabilityProbes(state),
  libraries: selectLibraryEntities(state),
  availabilities: selectAvailabilityEntities(state),
  currentLibrary: selectCurrentLibrary(state)
});

export default connect(mapStateToProps)(ConnectedLibraryPanelContainer);
